<rask-header [uppercase]="true">
    VACS
</rask-header>
<rask-container-block>
    <ng-container header>Exportera XML från VACS Kontrakt</ng-container>
    <rask-input label="Kontraktsnummer (Virkesköp)" [(ngModel)]="kontraktsNummer"></rask-input>
    <rask-input label="Arbetsorder-beteckning (Egen skog)" [(ngModel)]="arbetsorderBeteckning"></rask-input>
    <ng-container footer>
        <rask-button color="secondary" [disabled]="!isValidForExport()"
            (click)="exportXmlFromVacsKontrakt()">
            Exportera
        </rask-button>
    </ng-container>
</rask-container-block>
